import {  useQuery, } from '@tanstack/react-query';
import { useAllNotificationApi } from '../../hooks/useAllNotificationApi';


type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useAllNotification = (queryParams: Params) => {
  
  const { getAllNotification } = useAllNotificationApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getNotification', queryParams],
    queryFn: () => {
      return getAllNotification(queryParams);
    },
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch,
  };
};




